import * as Yup from "yup";
import { FormField } from "../../common/Form";
import { PrivacyText } from "../../pages/Contatti/Privacy-text";

export function registrazioneFormFields(): Array<FormField> {
  return [
    {
      id: 'username',
      label: 'Nome utente',
      name: 'username',
      type: 'text',
      required: true,
      className: 'form-control',
      placeholder: 'Inserisci il tuo nome utente',
      validation: Yup.string()
        .min(3, "Il campo deve essere di almeno 6 caratteri")
        .max(26, "Il campo deve essere di massimo 26 caratteri")
        .required("Campo obbligatorio"),
      icon: <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.5" cy="20.5" r="20.5" fill="#E63F4B" />
        <path d="M11.5958 31.1728C11.5958 31.1728 9.81641 31.1728 9.81641 29.3934C9.81641 27.6141 11.5958 22.2759 20.4927 22.2759C29.3895 22.2759 31.1689 27.6141 31.1689 29.3934C31.1689 31.1728 29.3895 31.1728 29.3895 31.1728H11.5958Z" fill="#F9F9F9" />
        <path d="M20.4927 20.4966C23.4408 20.4966 25.8308 18.1066 25.8308 15.1584C25.8308 12.2103 23.4408 9.82031 20.4927 9.82031C17.5445 9.82031 15.1545 12.2103 15.1545 15.1584C15.1545 18.1066 17.5445 20.4966 20.4927 20.4966Z" fill="#F9F9F9" />
      </svg>
    },
    {
      id: 'email_address',
      label: 'Email',
      name: 'email_address',
      type: 'email',
      required: true,
      className: 'form-control',
      placeholder: 'Inserisci il tuo indirizzo email',
      validation: Yup.string()
        .email("Il campo deve essere un indirizzo email valido")
        .min(10, "Il campo deve essere di almeno 10 caratteri")
        .max(180, "Il campo deve essere di massimo 180 caratteri")
        .required("Campo obbligatorio"),
      icon: <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.5" cy="20.5" r="20.5" fill="#E63F4B" />
        <path d="M9.17997 14.1716C9.46778 12.9036 10.6018 11.957 11.9569 11.957H29.0419C30.397 11.957 31.531 12.9036 31.8188 14.1716L20.4994 21.089L9.17997 14.1716ZM9.10938 15.797V25.9106L17.3717 20.8462L9.10938 15.797ZM18.7359 21.6799L9.38255 27.4131C9.8392 28.3761 10.8203 29.042 11.9569 29.042H29.0419C30.1785 29.042 31.1596 28.3761 31.6162 27.4131L22.2628 21.6799L20.4994 22.7576L18.7359 21.6799ZM23.6271 20.8462L31.8894 25.9106V15.797L23.6271 20.8462Z" fill="#F9F9F9" />
      </svg>
    },
    {
      id: 'password',
      label: 'Password',
      name: 'password',
      type: 'password',
      required: true,
      className: 'form-control',
      placeholder: 'Inserisci la tua password',
      validation: Yup.string()
        .min(6, "Il campo deve essere di almeno 6 caratteri")
        .max(32, "Il campo deve essere di massimo 32 caratteri")
        .matches(
          /[a-z]/,
          "La password deve contenere almeno una lettera minuscola"
        )
        .matches(
          /[A-Z]/,
          "La password deve contenere almeno una lettera maiuscola"
        )
        .matches(
          /[0-9]/,
          "La password deve contenere almeno un carattere numerico"
        )
        .matches(
          /[!@#$%^&*()\-+={}[\]:;"'<>,.?\/|\\]/, // eslint-disable-line
          "La password deve contenere almeno un carattere speciale"
        )
        .required("Campo obbligatorio"),
      icon: <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.5" cy="20.5" r="20.5" fill="#E63F4B" />
        <path d="M20.3906 11.3594C22.1579 11.3594 23.5906 12.4787 23.5906 13.8594V18.8594H17.1906V13.8594C17.1906 12.4787 18.6233 11.3594 20.3906 11.3594ZM25.1906 18.8594V13.8594C25.1906 11.7883 23.0416 10.1094 20.3906 10.1094C17.7397 10.1094 15.5906 11.7883 15.5906 13.8594V18.8594C13.8233 18.8594 12.3906 19.9787 12.3906 21.3594V27.6094C12.3906 28.9901 13.8233 30.1094 15.5906 30.1094H25.1906C26.9579 30.1094 28.3906 28.9901 28.3906 27.6094V21.3594C28.3906 19.9787 26.9579 18.8594 25.1906 18.8594Z" fill="#F9F9F9" />
      </svg>,
      description: <>
        <div className="password-title">
          La password deve:
        </div>
        <ul>
          <li>Contenere almeno un simbolo (&,%,$...)</li>
          <li>Essere lunga almeno 6 caratteri</li>
          <li>Avere almeno una lettera maiuscola</li>
          <li>Non essere uguale al tuo nome utente o alla tua mail</li>
        </ul>
      </>,
    },
    {
      id: 'repeat_password',
      label: 'Ripeti password',
      name: 'repeat_password',
      type: 'password',
      required: true,
      className: 'form-control',
      placeholder: 'Ripeti la tua password',
      validation: Yup.string()
        .min(6, "Il campo deve essere di almeno 6 caratteri")
        .max(32, "Il campo deve essere di massimo 32 caratteri")
        .matches(
          /[a-z]/,
          "La password deve contenere almeno una lettera minuscola"
        )
        .matches(
          /[A-Z]/,
          "La password deve contenere almeno una lettera maiuscola"
        )
        .matches(
          /[0-9]/,
          "La password deve contenere almeno un carattere numerico"
        )
        .matches(
          /[!@#$%^&*()\-+={}[\]:;"'<>,.?\/|\\]/, // eslint-disable-line
          "La password deve contenere almeno un carattere speciale"
        )
        .required("Campo obbligatorio"),
      icon: <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20.5" cy="20.5" r="20.5" fill="#E63F4B" />
        <path d="M20.3906 11.3594C22.1579 11.3594 23.5906 12.4787 23.5906 13.8594V18.8594H17.1906V13.8594C17.1906 12.4787 18.6233 11.3594 20.3906 11.3594ZM25.1906 18.8594V13.8594C25.1906 11.7883 23.0416 10.1094 20.3906 10.1094C17.7397 10.1094 15.5906 11.7883 15.5906 13.8594V18.8594C13.8233 18.8594 12.3906 19.9787 12.3906 21.3594V27.6094C12.3906 28.9901 13.8233 30.1094 15.5906 30.1094H25.1906C26.9579 30.1094 28.3906 28.9901 28.3906 27.6094V21.3594C28.3906 19.9787 26.9579 18.8594 25.1906 18.8594Z" fill="#F9F9F9" />
      </svg>
    },
    {
      id: 'tos-text',
      name: 'tos-text',
      type: 'custom',
      customElement: <>
        <h3 className="my-3 pb-3 terms-title">Termini e condizioni:</h3>
        <div className="tos-text">
          <PrivacyText />
        </div>
      </>
    },
    {
      id: 'tos',
      label: 'Accetta condizioni',
      name: 'tos',
      type: 'radio',
      required: true,
      className: 'mb-4',
      validation: Yup.string().required("Campo obbligatorio").matches(
        new RegExp("on"),
        "E' obbligatorio accettare i termini e le condizioni d'uso"
      ),
    },
  ]
}